import { Modal, Button } from 'react-bootstrap'

const AppModal = ({
    show,
    title,
    children,
    onCancel,
    onConfirm,
    cancelText = () => 'Cancel',
    confirmText = () => 'Confirm',
    centered = true,
    size = 'md',
    confirmDisabled = false,
    hideConfirmButton = false,
    hideCancelButton = false,
    renderFooter = true,
    dialogClassName,
    theme = 'dark',
}) => {
    const headerClass = theme === 'dark' ? 'bg-dark text-white' : 'bg-white text-dark'
    const bodyClass = theme === 'dark' ? 'bg-dark text-white' : 'bg-white text-dark'
    const footerClass = theme === 'dark' ? 'bg-dark text-white' : 'bg-white text-dark'

    return (
        <Modal
            show={show}
            onHide={onCancel}
            centered={centered}
            size={size}
            backdrop="static"
            backdropClassName={`show theme-${theme} mediabuy-modal-backdrop`}
            dialogClassName={`app-modal ${dialogClassName}`}
        >
            <Modal.Header closeButton className={headerClass}>
                <Modal.Title className="modal-title-20">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={bodyClass}>{children}</Modal.Body>
            {renderFooter && (
                <Modal.Footer className={footerClass}>
                    {!hideCancelButton && (
                        <Button variant="outline-secondary" onClick={onCancel} className="btn-14px">
                            {typeof cancelText === 'function' ? cancelText() : cancelText}
                        </Button>
                    )}
                    {!hideConfirmButton && (
                        <Button variant="primary" onClick={onConfirm} disabled={confirmDisabled} className="btn-14px">
                            {typeof confirmText === 'function' ? confirmText() : confirmText}
                        </Button>
                    )}
                </Modal.Footer>
            )}
        </Modal>
    )
}

export default AppModal
